var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"close-popper",rawName:"v-close-popper"}],staticClass:"group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900",attrs:{"type":"button","role":"menuitem"},on:{"click":_vm.create}},[_vm._v(" SoftOne API ")])
}
var staticRenderFns = []

export { render, staticRenderFns }